import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Input } from 'Components';
import FormikTextField from './Formik';
import './TextField.css';

const TextField = ({
  title,
  required,
  className,
  icon,
  sideText,
  sideTextTheme,
  asterisk,
  visibilityIcon,
  ...rest
}) => (
  <div className={classNames('text-field', className)}>
    {title && (
      <div className="text-field__label">
        <span>{title}</span>
        {required && <span className="text-field__required">*</span>}
        {/* Just a simple asterisk to display, no functionality attached with it */}
        {asterisk && !required && (
          <span className="text-field__required">*</span>
        )}
      </div>
    )}

    <Input required={required} {...rest} />
    {visibilityIcon && <i className="material-icons text-field__password-eye">{visibilityIcon}</i>}
    {icon && <i className="material-icons">{icon}</i>}
    {sideText && (
      <p
        className={classNames({
          'text-field__side-text-theme__red': sideTextTheme === 'red',
          'text-field__side-text-theme__blue': sideTextTheme === 'blue',
        })}
      >
        {sideText}
      </p>
    )}
  </div>
);

TextField.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  sideText: PropTypes.string,
  sideTextTheme: PropTypes.string,
  asterisk: PropTypes.bool,
  visibilityIcon: PropTypes.bool,
};

TextField.Formik = FormikTextField; // Formik Specific TextField
export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/TextField.jsx